import type { DisplayText } from "./dto/DisplayText.js"
import es from "./es.js"

/**
 * @description
 *	Dictionary for es-EC locale. Inherits the Spanish base as is, like every
 *	Spanish locale; the base tells why they all read the same.
 */
const esEC: DisplayText = { ...es }

export default esEC
